import { Select } from "antd";
import { CheckCircleFilled, InfoCircleFilled } from "@ant-design/icons";
import styles from "./OffPlatform.module.scss";
import { PortalOptions, RowType } from "../shared/types";
import { HandleSelectPortalOptions, PortalOptionMatchTableData } from "./types";
import { MappingDataForExportPortal } from "shared/types/assetExporter";

export const getColumns = (
  portalOptionMatches: MappingDataForExportPortal,
  handleSelectPortalOption: HandleSelectPortalOptions,
) => [
  {
    title: "Feed columns",
    dataIndex: "title",
  },
  {
    width: 50,
    align: "center" as const,
    render: (_: string, rowData: PortalOptionMatchTableData) => {
      const isMediaRow = rowData.rowType === RowType.Media;
      const isMatch =
        isMediaRow ||
        portalOptionMatches.tags?.includes(rowData.key) ||
        portalOptionMatches.metas?.includes(rowData.key) ||
        portalOptionMatches.notInclude?.includes(rowData.key);

      return isMatch ? (
        <CheckCircleFilled className={styles.checkIcon} />
      ) : (
        <InfoCircleFilled className={styles.infoIcon} />
      );
    },
  },
  {
    title: "Show in the Portal as",
    render: (_: string, rowData: PortalOptionMatchTableData) => {
      const isMediaRow = rowData.rowType === RowType.Media;
      const isInternalColumn = [RowType.AssetBatch, RowType.AssetName].includes(
        rowData.rowType,
      );

      const getValue = () => {
        if (isMediaRow) return PortalOptions.Filename;
        if (portalOptionMatches.tags?.includes(rowData.key))
          return PortalOptions.Filters;
        if (portalOptionMatches.metas?.includes(rowData.key))
          return PortalOptions.Metadata;
        if (portalOptionMatches.notInclude?.includes(rowData.key))
          return PortalOptions.DoNotImport;
        return undefined;
      };

      const getOptions = () => {
        const mapAsOption = { label: <span>Map as</span>, value: "" };
        const doNotImportOption = {
          label: <span>Do not import</span>,
          value: PortalOptions.DoNotImport,
        };
        const portalOptions = {
          label: <span>Options</span>,
          options: [
            { label: <span>Filters</span>, value: PortalOptions.Filters },
            { label: <span>Metadata</span>, value: PortalOptions.Metadata },
          ],
        };

        if (isInternalColumn) return [mapAsOption, portalOptions];
        return [mapAsOption, doNotImportOption, portalOptions];
      };

      return (
        <Select
          placeholder="Map as"
          value={getValue()}
          disabled={isMediaRow}
          onSelect={recommendedColumnTitle =>
            handleSelectPortalOption(recommendedColumnTitle, rowData)
          }
          className={styles.columnTitleInput}
          options={getOptions()}
        />
      );
    },
  },
];
